import { useEffect } from 'react';
import constants from '../../constants';
import useIsOutsideIndiaFlow from './useIsOutsideIndiaFlow';

const useOutsideIndiaLoginType = ({ changeLoginType, loginType }) => {
  const isOutsideIndiaFlow = useIsOutsideIndiaFlow();
  useEffect(() => {
    if (isOutsideIndiaFlow && loginType === constants.LOGIN_TYPE_NUMBER)
      changeLoginType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOutsideIndiaFlow]);
};

export default useOutsideIndiaLoginType;
